<template>
	<div :class="toastBgShow?'toastBg':''">

	</div>
</template>

<script>
	export default {
		props: {
			title: {
				type: String,
				default: '提示'
			}
		},
		data() {
			return {
				toastBgShow: true
			}
		},
		methods: {
			openToast(message) {
				this.$message({
					dangerouslyUseHTMLString: true,
					iconClass: 'none',
					customClass: 'customClass',
					message: "<div class='flex'><div class='img'></div><div class='title'>" + this.title +
						"</div></div><div class='message'>" + message + "</div>"
				});
				setTimeout(() => {
					this.toastBgShow = false
				}, 3000)
			},
		}
	}
</script>

<style lang="less">
	.customClass {
		width: 378px;
		min-width: 378px;
		background: #FFFFFF;
		border-radius: 13px 13px 13px 13px;
		border-color: #FFFFFF;
		display: block;
		padding: 22px;

		.img {
			background: url('../assets/images/icon/arco-notification-icon.png') no-repeat;
			background-size: 100% 100%;
			width: 27px;
			height: 27px;
		}

		.title {
			margin-left: 18px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 18px;
			color: #333333;
		}

		.message {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #666666;
			line-height: 24px;
			margin-top: 4px;
			margin-left: 45px;
		}
	}

	.toastBg {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		min-height: 100vh;
		background: rgba(0, 0, 0, 0.36);
	}
</style>